import React, { useEffect, useState } from "react";
import "./CurrentPlaceName.css";

const CurrentPlaceName = ({ locality, region }) => {
  const [currentPlaceName, setCurrentPlaceName] = useState("...");

  useEffect(() => {
    if (region !== "") {
      setCurrentPlaceName(locality + ", " + region);
    }
  }, [locality, region]);

  return (
    <div>
      <h2 id="currentPlaceNameText">{currentPlaceName}</h2>
    </div>
  );
};

export { CurrentPlaceName };
